<template>
  <div class="boxShadow">
    <div class="the-nav">
      <!-- 菜单折叠按钮 -->
      <div class="nav-handle-collapse">
        <span class="systemName">{{$t('i18n_system_name')}}</span>
      </div>
      <!-- <div class="pager-msg">广播：{{subappMsg}}</div>  -->
      <!-- 右侧操作区 -->
      <div class="nav-handle-box">
        <!-- 用户名 -->
        <!-- <span class="nav-handle-item nav-user-name">{{user_name}}</span> -->
        <!-- 退出登录按钮 -->
        <!-- <el-button type='text' @click='chagnePWD'>修改密码</el-button>
      <i class="nav-icon nav-handle-item el-icon-switch-button" @click="logOut()"></i> -->
        <!-- <span class="box" v-show="this.show"> -->
        <span class="box">
          <el-select
            v-model="language"
            @change="handleLanguageChange"
            size="small"
            class="avue-tags__menu_mini"
            style="width: 80px"
          >
            <el-option label="中文" value="zh_cn"></el-option>
            <el-option label="English" value="en"></el-option>
          </el-select>
        </span>
        <span
          v-if="is_purchaser === '1'"
          class="msg-box"
          @click="messageClickHandle"
        >
          <i
            style="color: #409eff; font-size: 22px; font-style: blod"
            class="el-icon-bell"
          ></i>
          <span v-show="messageUnreadCount" class="msg-count">{{
            messageUnreadCount
          }}</span>
        </span>
        <el-dropdown
          class="top-bar__item top-bar__user"
          @command="handleCommand"
        >
          <span class="el-dropdown-link">
            {{ user_name }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!--<el-dropdown-item>
            <router-link to="/portal/info">{{ $t('i18n_frame_page-index-top') }}</router-link>
          </el-dropdown-item>-->

            <el-dropdown-item divided v-if="is_purchaser === '1'">
              <el-button type="text" @click.stop="chagnePWD">
                <span style="font-size: 14px">{{
                  $t("i18n_Change_Password")
                }}</span>
              </el-button>
            </el-dropdown-item>
            <el-dropdown-item divided>
              <el-button type="text" @click.stop="logOut">
                <span style="font-size: 14px">{{
                  $t("i18n_Exit_system")
                }}</span>
              </el-button>
            </el-dropdown-item>
            <!--<el-dropdown-item @click="logExit" command="logExit" divided>
            {{
            $t('i18n_frame_page_top_tcxt')
            }}
          </el-dropdown-item>-->
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <Tags></Tags>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Tags from "./tags";
import actions from "@/util/actions";
import { getStore, removeStore } from "@/util/store";
import { routerGo } from "@/util/utils.js"; // 引入跨应用路由跳转
// import { getPortalUrl } from "@/api/menu";
import { setup } from "../../locales";
export default {
  name: "theNav",
  components: { Tags },
  data() {
    return {
      user_name: "Admin", // 名称 // 用户信息
      full_screen: false, // 是否全屏
      show: false, //是否供应商端
      user_code: "",
      is_purchaser: "", // 0供应商  1采购端
    };
  },
  computed: {
    language() {
      return this.$store.state.appstore.language;
    },
    messageUnreadCount() {
      return this.$store.state.appstore.messageUnreadCount;
    },
    ...mapGetters([{ subappMsg: "msg" }, "tagWel"]),
  },
  watch: {
    user_code: {
      handler(newName) {
        if (newName === undefined) {
          this.$nextTick().then(() => {
            this.show = true;
          });
        }
      },
    },
  },
  created() {
    const userInfo = getStore({ name: "userInfo" }) || {};
    this.user_name = userInfo.name;
    this.admin = userInfo.is_admin;
    this.user_code = userInfo.user_code;
    this.is_purchaser = userInfo.is_purchaser;
    const queryStr = window.location.hash.split("?")[1];
    const hashParams = new URLSearchParams(queryStr);
    const lang = hashParams.get("lang");
    console.log(hashParams, lang, "lang");
    const LOCALE_KEY = "localeLanguage";
    if (lang) {
      actions.setGlobalState({ language: lang, title: "", href: "" });

      this.$store.dispatch("appstore/setLanguage", lang);
      this.language = lang;
      window.localStorage.setItem(LOCALE_KEY, lang);
    }
  },
  methods: {
    handleLanguageChange(value) {
      this.$confirm(`<div><div>切换语言版本会刷新页面，如果已有编辑的内容，请先保存再切换语言版本。</div><div>Switching language versions will refresh the page,If you have already edited content, Please save it before switching language versions.</div></div>`,'',{
        confirmButtonText:'确定',
        cancelButtonText:'取消',
        dangerouslyUseHTMLString:true,
      }).then(() => {
        setup(value);
        actions.setGlobalState({ language: value, title: "", href: "" });
        this.$store.dispatch("appstore/setLanguage", value);
        location.reload()
      }).catch(() => {

      })
      // setup(value);
      // actions.setGlobalState({ language: value, title: "", href: "" });
      // this.$store.dispatch("appstore/setLanguage", value);
      // location.reload();
    },
    // 暂未开通，敬请期待
    notYetOpened() {
      this.$message({});
    },
    messageClickHandle() {
      routerGo(this.tagWel.value, "首页");
      this.$root.$emit("openTag", {
        label: "首页",
        value: this.tagWel.value,
      });
      actions.setGlobalState({ openMessageList: true, title: "", href: "" });
    },
    //
    chagnePWD() {
      this.$emit("checkThis", true);
      this.$store.dispatch("app/setPassword", true);
    },
    handleCommand() {
      console.log(".");
    },
    // 退出登录
    // logOut() {
    //   removeStore({ name: "userInfo" });
    //   removeStore({ name: "tagList" });
    //   removeStore({ name: "tag" });
    //   removeStore({ name: "menu" });
    //   // 设置成默认语言
    //   this.$store.dispatch(
    //     "appstore/setLanguage",
    //     process.env.VUE_APP_DEFAULT_LANGUAGE
    //   );
    //   location.href = "/";
    // }
    logOut() {
      // const portalUrl = await getPortalUrl().then(res => {
      //   if (res.code === 200 && res.success) {
      //     return res.data;
      //   }
      // });
      removeStore({ name: "userInfo" });
      removeStore({ name: "tagList" });
      removeStore({ name: "tag" });
      removeStore({ name: "menu" });
      removeStore({ name: "supplierSpecial" });
      removeStore({ name: "aptitudeWarning" });
      removeStore({ name: "agentAuth" });
      removeStore({ name: "qualifiedSupplier" });
      removeStore({ name: "supplierContacts" });
      removeStore({ name: "customSupplier" });
      // 设置成默认语言
      this.$store.dispatch(
        "appstore/setLanguage",
        process.env.VUE_APP_DEFAULT_LANGUAGE
      );
      this.$store.dispatch("appstore/setMessageUnreadCount", 0);
      if (this.is_purchaser === "1") {
        location.replace("/");
      } else {
        window.close();
      }
    },
  },
};
</script>

<style lang="scss">
.boxShadow {
  z-index: 1;
  box-shadow: 0px 0px 16px -4px rgba(0, 0, 0, 0.3);
}
.box {
  margin-right: 20px;
}
.systemName {
  font-family: PingFangSC-Medium;
  font-size: 18px;
  color: #313233;
  letter-spacing: 0;
  line-height: 26px;
  font-weight: 600;
  //margin-left: 15px;
}
// .the-nav{
//   display: flex;
//   justify-content: space-between;
//   z-index: 1;
//   height: $header-height;
//   padding: $header-padding 20px;
//   line-height: $header-height - ($header-padding * 2);
//   background: #ffffff;
//   color: #333;
//   box-sizing: border-box;
// }
.avue-tags__menu_mini .el-input--small .el-input__inner {
  height: 25px;
  line-height: 25px;
}
.avue-tags__menu_mini .el-input--small .el-input__icon {
  line-height: 25px;
}
.the-nav {
  display: flex;
  justify-content: space-between;
  z-index: 1;
  height: $header-height;
  padding: $header-padding 20px;
  line-height: $header-height - ($header-padding * 2);
  background: #ffffff;
  color: #333;
  box-sizing: border-box;
  .nav-handle-box {
    display: flex;
    align-items: center;
  }
  .nav-icon,
  .nav-user-name {
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
  }
  .nav-handle-collapse {
    flex: 1;
    display: flex;
    align-items: center;
  }

  .nav-handle-item + .nav-handle-item {
    margin-left: 12px;
  }

  .pager-msg {
    font-weight: 600;
    font-size: 16px;
  }

  .msg-box {
    position: relative;
    align-self: center;
    height: 30px;
    margin-right: 15px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;

    .msg-count {
      position: absolute;
      top: -7px;
      right: -9px;
      padding: 0 3px;
      min-width: 23px;
      height: 16px;
      border-radius: 8px;
      color: #ffffff;
      background-color: #ff0000;
      font-size: 10px;
      text-align: center;
      line-height: 16px;
      z-index: 10;
    }
  }
}
</style>
